import React from "react";
import { Description } from "./Description";

export const Works = ({ works }) => {
  return (
    <section className="work-experience section" id="experience">
      <h2 className="section-title">Experience</h2>
      <div className="timeline">
        {works.map((work) => (
          <Work key={`${work.company}-${work.title}`} {...work} />
        ))}
      </div>
    </section>
  );
};

const Work = ({ title, period, company, description }) => {
  return (
    <article className="timeline-item card">
      <div className="timeline-header">
        <span className="timeline-pill">{period}</span>
        <span className="timeline-subtitle">{company}</span>
      </div>
      <h3 className="timeline-title">{title}</h3>
      <ul className="timeline-list">
        {description.map((desc, index) => (
          <Description key={index} desc={desc} />
        ))}
      </ul>
    </article>
  );
};